import React, { useCallback, useContext, useState } from "react";
import { withRouter, Redirect, history, useHistory } from "react-router";
import { Link } from 'react-router-dom';
import firebase from './components/Firebase';
import { AuthContext } from "./components/Auth.js";
import { Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/registrazione.css';
import signup from './img/signup.png';
import signin from './img/signin.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import GoogleLogin from "./components/GoogleLogin";
import ReCAPTCHA from "react-google-recaptcha";

const Login = ({ history }) => {
    const [password, setPassword] = useState('password');
    const [accepted, setAccepted] = useState(false);
    const [captchaResult, setCaptchaResult] = useState()

    const handleLogin = useCallback(
        async event => {
            event.preventDefault();
            const { email, password } = event.target.elements;
            try {
                await firebase.auth().signInWithEmailAndPassword(email.value, password.value);
                history.push("/");
            } catch (error) {
                alert(error);
            }
        },
        [history]
    );

    const handleSignUp = useCallback(async event => {
        event.preventDefault();
        const { email, password, username } = event.target.elements;
        try {
            if(username.value.length === 0){ 
                throw "Username can not be empty."}
            await firebase.auth().createUserWithEmailAndPassword(email.value, password.value);
            await firebase.auth().currentUser.updateProfile({ displayName: username.value });
            history.push("/");
        } catch (error) {
            alert(error);
        }

    }, [history]);

    const { currentUser } = useContext(AuthContext);

    if (currentUser) return <Redirect to="/" />;

    function toggleform() {
        var section = document.querySelector('section');
        var container = document.querySelector('.container');
        container.classList.toggle('active');
        section.classList.toggle('active');
    }

    return (
        <div>
            <Link>
                <p style={{textAlign:"center", fontSize: "25px", marginTop: "5%"}} onClick={() => history.goBack()}>
                    <FontAwesomeIcon icon={faTimesCircle} color="lightgrey"/>
                </p>    
            </Link>
        <section style={{minHeight: 0}}>
            <div className="container">
               <div className="user signinBx">
                    <div className="imgBx"><img src={signin} alt="" /></div>
                    <div className="formBx" style={{flexFlow: "column"}}>
                        <Form onSubmit={handleLogin}>
                            <h2>Accedi</h2>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Control name="email" type="email" placeholder="Inserisci l'email" />
                            </Form.Group>
                            <div className="row" style={{justifyContent: "space-evenly", alignItems: "center"}}>
                                <Form.Control name="password" type={password} placeholder="Password" style={{width: "75%"}}/>
                                {password === 'text' ?
                                    <FontAwesomeIcon icon={faEyeSlash} onClick={() => setPassword('password')} /> :
                                    <FontAwesomeIcon icon={faEye} onClick={() => setPassword('text')} />
                                }
                            </div>
                                
                            <Button variant="primary" type="submit" >Accedi</Button>
                            <p className="signup">non hai un account? <a onClick={toggleform} style={{cursor: "pointer"}}>Iscriviti</a></p>
                            <hr className='visibleSeparator' />
                            <GoogleLogin />
                        </Form>
                    </div>
                </div>
                <div className="user signupBx">
                    <div className="formBx">
                        <Form onSubmit={handleSignUp}>
                            <h2>Crea un account</h2>
                            <Form.Group controlId="formBasicUsername">
                                <Form.Control name="username" type="username" placeholder="Username" />
                                <Form.Control.Feedback type="valid">Va bene!</Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">Non va bene</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Control name="email" type="email" placeholder="Email" />
                                <Form.Control.Feedback type="valid">Va bene!</Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">Non va bene</Form.Control.Feedback>
                            </Form.Group>
                            <div className="row" style={{justifyContent: "space-evenly", alignItems: "center"}}>
                                <Form.Control name="password" type={password} placeholder="Password" style={{width: "75%"}}/>
                                {password === 'text' ?
                                    <FontAwesomeIcon icon={faEyeSlash} onClick={() => setPassword('password')} /> :
                                    <FontAwesomeIcon icon={faEye} onClick={() => setPassword('text')} />
                                }
                            </div>
                                
                            <div className="row" style={{justifyContent: "space-around", alignItems: "center"}}>
                                <text style={{fontSize: "12px"}}>Accetto i <a href="https://www.iubenda.com/termini-e-condizioni/24709192" target="_blank" rel="noopener noreferrer">Termini</a> e <a href="https://www.iubenda.com/privacy-policy/24709192" target="_blank" rel="noopener noreferrer">Policy</a>.</text>
                                <Form.Control style={{width: "8%"}} name="checkbox" type="checkbox" input={false} onInputCapture={input => setAccepted(!accepted)}/>
                            </div>
                            <Button variant="primary" type="submit" disabled={!accepted}>Registrati</Button>
                            <hr className='visibleSeparator' /><p class="signup">hai un account?<a onClick={toggleform} style={{cursor: "pointer"}}>Accedi</a></p>
                        </Form>
                    </div>
                    <div className="imgBx"><img src={signup} alt="" /></div>
                </div>
            </div>
        </section>
        </div>
    );
};

export default withRouter(Login);